module.exports = __webpack_public_path__ + "assets/images/project/head/Ko_Jin-young.jpg?v=d564a882";